import { type ComponentType, FC, useEffect } from 'react'
import { useUserTarget } from 'modules/user'
import { STORE_STATUS_FINISHED } from 'constants/store'
import { CompanyType } from '@types'

export const withUserTarget = <P extends object>(
  Component: ComponentType<P>
): FC<P> => {
  function withUserTarget(props: P) {
    const { auth, client, setHotjar, setIdentity } = useUserTarget()

    useEffect(() => {
      if (auth.status === STORE_STATUS_FINISHED) {
        const currentCompany = client.data.currentCompany

        setHotjar()
        setIdentity({
          companyId: currentCompany.id,
          id: client.data.id || auth.data.uid,
          email: auth.data.email,
          authId: auth.data.uid,
          admin: client.data.is_admin,
          companyType: currentCompany.is_buyer
            ? CompanyType.Merchant
            : CompanyType.Supplier,
        })
      }
    }, [client.status, client.data.currentCompany, auth.status])

    return <Component {...props} />
  }

  return withUserTarget
}
